import * as Sentry from '@sentry/nextjs'
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { CookieContext } from '../context/cookieContext';
import IntercomTracker from "../tracking/Intercom";
import MixpanelTracker from "../tracking/Mixpanel";
import { signOutSession } from "../api/session";
import { logError } from "../logging/logSentryError";
import { clearLocalSession } from "../utils/session";
import { toError } from "../utils/toError";
import { getAuthenticatedUserClient } from '../utils/getAuthenticatedUser';

/**
 * Signs the user out, ending the session and the trackers.
 * @param destination Where the browser goes once signed out
 * @returns The sign out handler
 */
export const useSignOut = (destination = "/") => {
    const router = useRouter();
    const token = useContext(CookieContext);
    const { authenticatedUser: { data } } = getAuthenticatedUserClient(token, router, true);

    return async () => {
        if (token) {
            try {
                await signOutSession(token);
            } catch (e) {
                logError(toError(e));
            }
        }

        clearLocalSession();

        // Shutdown intercom
        const intercomTracker = new IntercomTracker(data, true);
        intercomTracker.shutdown();

        // Shutdown mixpanel
        const mixpanelTracker = new MixpanelTracker(data);
        mixpanelTracker.shutdown();

        // Clear Sentry scope
        Sentry.getCurrentScope().setUser(null);

        document.location.href = destination;
    }
}